export default "__VITE_ASSET__CxjmhZnT__"